import { getGoodsSupplyCase, getGoodsSupplyData, GoodsSupplyCase } from 'features/goods-supply';
import { getIsUnavailable } from 'features/product-info';
import React from 'react';
import { connect } from 'react-redux';
import { RootReducer } from 'store/root-reducer';
import { Skeleton } from 'common/components/skeleton';
import { cx } from 'linaria';
import { ContentBySupplyCase, GoodIsOutOfStockContent } from './fragments';
import { firstSkeleton, secondSkeleton, skeleton, SkeletonContainer, threeSkeleton } from './styles';

export const DATA_QA_SKELETON_CONTAINER = 'availability-to-buy-skeleton-container';

export type AvailabilityToBuyMappedState = {
  isSupplyDataLoaded?: boolean;
  isUnavailable: boolean;
  supplyCase: GoodsSupplyCase | null;
};

export type AvailabilityToBuyProps = AvailabilityToBuyMappedState &
  React.HTMLAttributes<HTMLElement> & {
    hideButton?: boolean;
  };

export const AvailabilityToBuy: React.FC<AvailabilityToBuyProps> = ({
  isSupplyDataLoaded,
  supplyCase,
  isUnavailable,
  hideButton,
}) => {
  if (isUnavailable) {
    return <GoodIsOutOfStockContent hideButton={hideButton} />;
  }
  if (isSupplyDataLoaded) {
    return supplyCase !== null ? (
      <ContentBySupplyCase supplyCase={supplyCase} />
    ) : (
      <GoodIsOutOfStockContent hideButton={hideButton} />
    );
  }
  return (
    <SkeletonContainer data-qa={DATA_QA_SKELETON_CONTAINER}>
      <Skeleton blink className={cx(skeleton, firstSkeleton)} />
      <Skeleton blink className={cx(skeleton, secondSkeleton)} />
      <Skeleton blink className={cx(skeleton, threeSkeleton)} />
    </SkeletonContainer>
  );
};

const mapStoreToProps = (store: RootReducer): AvailabilityToBuyMappedState => {
  const isUnavailable = getIsUnavailable(store);
  const supplyCase = getGoodsSupplyCase(store);
  const supplyData = getGoodsSupplyData(store);

  return {
    isUnavailable,
    supplyCase,
    isSupplyDataLoaded: !!supplyData,
  };
};

export const PdpAvailabilityToBuy = connect(mapStoreToProps)(AvailabilityToBuy);
